import { Box, ThemeProvider, useMediaQuery, useTheme } from '@mui/material';
import { capitalMuiDarkTheme, capitalMuiTheme } from '@opengov/capital-mui-theme';
import { useMemo } from 'react';
import { DATA_TEST } from './enums';
import { ResultContext } from './ResultContext';
import type { ResultBaseProps } from './types';

export const ResultBase = ({
  size = 'medium',
  status = 'empty',
  children,
  sx = {},
  dataTest,
  placeholderContainer = false
}: ResultBaseProps) => {
  const outerTheme = useTheme();
  const innerTheme = outerTheme.palette.mode === 'dark' ? capitalMuiDarkTheme : capitalMuiTheme;
  // Phones take the compact layout: the theme's `xs` range, below `sm`.
  const isMobile = useMediaQuery(innerTheme.breakpoints.down('sm'));
  const contextValue = useMemo(
    () => ({ size, isMobile, status, placeholderContainer }),
    [size, isMobile, status, placeholderContainer]
  );
  return (
    <ThemeProvider theme={innerTheme}>
      <ResultContext.Provider value={contextValue}>
        <Box
          sx={{
            textAlign: 'center',
            color: innerTheme.palette.text.secondary,
            ...(placeholderContainer && {
              backgroundColor: innerTheme.palette.background.default,
              border: `1px dashed ${innerTheme.palette.divider}`,
              borderRadius: '4px'
            }),
            ...sx
          }}
          data-test={dataTest ?? DATA_TEST.result_root}
        >
          {children}
        </Box>
      </ResultContext.Provider>
    </ThemeProvider>
  );
};
